"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wordCountRegex = /\S+/g;
function getWordCount(value) {
    var match = value && value.match(wordCountRegex);
    return match ? match.length : 0;
}
exports.getWordCount = getWordCount;
;
/**
 * this function can be used when doing string comparisons and it is desired
 * to use regular expressions. this will take the input text and escape special
 * regex characters so that the original string integrity is preserved
 * @param text text string to convert
 */
function convertStrToRegExStr(text) {
    var regExStr = text.replace("\\", "\\\\")
        .replace(".", "\\.")
        .replace("?", "\\?")
        .replace("+", "\\+")
        .replace("*", "\\*")
        .replace("^", "\\^")
        .replace("$", "\\$")
        .replace("|", "\\|")
        .replace("(", "\\(")
        .replace(")", "\\)")
        .replace("[", "\\[");
    return regExStr;
}
exports.convertStrToRegExStr = convertStrToRegExStr;
//# sourceMappingURL=text-utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/text-utilities.js
// module id = 1159
// module chunks = 0